export const topic = {
  hongKongChiefExecutiveElection2022: {
    entityId: "511618",
    entityUuid: "f2025ab2-c284-42a4-83fe-aa21e7ba6054",
    name: "Hong Kong chief executive election 2022",
    routeType: "Topic",
    urlAlias: "/topics/hong-kong-chief-executive-election-2022",
  },
  hongKongCouncilElection2021: {
    entityId: "510368",
    entityUuid: "0aa8899e-5015-4a4e-b71b-375a70190990",
    name: "Hong Kong Legislative Council election 2021",
    routeType: "Topic",
    urlAlias: "/topics/hong-kong-legislative-council-election-2021",
  },
  specialReports: {
    entityId: "322953",
    entityUuid: "1df9e8fc-a66c-4020-af3f-7ba680ea2000",
    name: "Special Reports",
    routeType: "Topic",
    urlAlias: "/topics/special-reports",
  },
} as const;
